import { useMutation } from "@apollo/client";

import { HALL_UPLOAD_FILE } from "graphql/mutation/hall-gql";
import { GET_HALL } from "graphql/query/hall-gql";

import { successNotification, errorNotification } from "components/request-result";


const useMutationHallUploadFile = ({ id }) => {

    const [ _setHallUploadFile, { loading } ] = useMutation(HALL_UPLOAD_FILE,
        {
            update(cache, { data }) {

                const {
                    fileUpload: {
                        label,
                        message,
                    }
                } = data;


                successNotification({
                    title: label,
                    description: message
                })
            },

            onError(error) {
                errorNotification(error);
            },

            refetchQueries: [
                {
                    query: GET_HALL,
                    variables: {
                        id
                    }
                },
            ]
        }
    );


    return {
        _setHallUploadFile,
        loadingMutationHallUploadFile: loading,
    }
};

export default useMutationHallUploadFile;

